<template>
  <v-container class="pa-0" fluid>
    <!-- criteria card -->
    <div v-if="showCriteriaCard" class="pt-4">
      <el-overlay-loading :loading="loading" />
      <v-card outlined>
        <v-card-title class="pt-1">{{
          $t('Ataskaitos informacija ir kriterijai')
        }}</v-card-title>
        <v-card-text>
          <v-row class="mb-0 pb-0">
            <template v-for="item in formData.fields">
              <v-col
                v-if="!item.hidden"
                :key="item.key"
                class="pb-0"
                cols="12"
                :md="item.md"
                :lg="item.lg"
              >
                <el-checkbox
                  v-if="item.type == 'checkbox'"
                  style="margin-top: 3px; margin-bottom: 15px"
                  :label="item.label"
                  v-model="formData.criteria[item.key]"
                  @click="clickedCheckBox(item)"
                >
                </el-checkbox>
                <el-date-picker
                  v-if="item.type == 'datePicker'"
                  :required="item.required"
                  :label="item.label"
                  v-model="formData.criteria[item.key]"
                />
                <el-text-field
                  v-if="item.type == 'textField'"
                  :required="item.required"
                  :label="item.label"
                  :type="item.number ? 'number' : 'text'"
                  :maxlength="item.maxlength ? item.maxlength : 255"
                  :cMask="item.cMask ? item.cMask : ''"
                  v-model="formData.criteria[item.key]"
                />
                <el-textarea
                  v-if="item.type == 'textArea'"
                  :rows="item.rows"
                  :maxlength="item.maxlength ? item.maxlength : 255"
                  :required="item.required"
                  :label="item.label"
                  v-model="formData.criteria[item.key]"
                />
                <el-autocomplete
                  class="multi-scroll"
                  v-if="item.type == 'select'"
                  :enums="item.enumName ? true : false"
                  :required="item.required"
                  :direct="!item.enumName ? true : false"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="item.multiple ? true : false"
                  :label="item.label"
                  v-model="formData.criteria[item.key]"
                  :items="
                    item.enumName
                      ? enumsClassifiers[item.enumName]
                      : item.options
                  "
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col class="pl-2 pb-2" cols="12">
              <el-button
                title="Formuoti naują ataskaitą"
                :loading="loading"
                @click.native="saveData()"
                color="primary"
                icon="pridėti"
              />
              <el-button
                class="ml-2"
                color="secondary"
                icon="išvalyti"
                title="Išvalyti"
                :loading="loading"
                @click.native="clearData"
              />
              <el-button
                v-if="fileData"
                class="ml-2"
                title="Atsisiųsti"
                :loading="loading"
                @click.native="downloadFile()"
                color="primary"
              />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <template v-if="isGroupedTable">
        <v-data-table
          v-if="excelData"
          :headers="excelData.headers"
          :items="excelData.rows"
          :item-class="rowClass"
          :custom-sort="customSort"
          class="elevation-1"
          item-value="name"
        ></v-data-table>
      </template>
      <template v-else>
        <v-data-table
          v-if="excelData"
          :headers="excelData.headers"
          :items="excelData.rows"
          class="elevation-1"
          item-value="name"
        ></v-data-table>
      </template>
    </div>
  </v-container>
</template>

<script>
import Enums from '@/enums'
import math from '@/mixins/math'
import ElCheckbox from '../../../../components/elements/ElCheckbox.vue'

export default {
  name: 'ReportCriteriaForm',
  components: {ElCheckbox},
  mixins: [math],
  props: {
    formData: Object,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loading: false,
      enumsClassifiers: [],
      fileData: null,
      excelData: null,
    }
  },
  computed: {
    isGroupedTable() {
      return (
        this.excelData &&
        this.excelData.rows[0]?.is_group_row &&
        this.excelData.rows[0].is_group_row == '1'
      )
    },
    showCriteriaCard() {
      if (this.formData.type && Object.keys(this.formData.type).length > 0) {
        this.setFields()
        return true
      } else {
        this.$set(this.formData, 'fields', [])
        return false
      }
    },
  },
  created() {
    this.enumsClassifiers = Enums
  },
  methods: {
    clickedCheckBox(item) {
      let cloneItem = JSON.parse(JSON.stringify(this.formData.criteria[item.key]))
      this.$emit('clear-criteria')
      this.formData.criteria[item.key] = cloneItem

      if (this.formData.criteria[item.key]) {
        item.show_1.forEach((key) =>
          this.formData.fields.forEach((element) => {
            if (element.key == key) {
                element.hidden = false
            }
          })
        )

        item.show_0.forEach((key) =>
          this.formData.fields.forEach((element) => {
            if (element.key == key) {
                element.hidden = true
            }
          })
        )
      } else {
        item.show_1.forEach((key) =>
          this.formData.fields.forEach((element) => {
            if (element.key == key) {
                element.hidden = true
            }
          })
        )

        item.show_0.forEach((key) =>
          this.formData.fields.forEach((element) => {
            if (element.key == key) {
                element.hidden = false
            }
          })
        )
      }
    },
    saveData() {
      this.loading = true
      this.$validator.validateAll().then((res) => {
        if (res) {
          const payload = {
            criteria: { ...this.formData.criteria },
            type: this.formData.type.reportSubType,
          }

          let url = `ireg-reports/preview`
          this.$axios
            .post(url, payload)
            .then((res) => {
              // this.$root.$emit('DATA_OK', res.data.message)
              this.fileData = res.data.fileData
              this.excelData = res.data.excelData
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
          this.loading = false
        }
      })
    },
    clearData() {
      this.$emit('clear-criteria')
      // this.$set(this.formData, 'criteria', [])
    },
    setFields() {
      this.loading = true
      this.$set(this.formData, 'fields', [])
      this.fileData = null
      this.excelData = null

      let reportType = this.formData.type.reportSubType
      let activeFields = []

      this.$axios
        .post(`ireg-reports/inputs/${reportType}`)
        .then((res) => {
          let fieldsDataArray = res.data
          Object.entries(fieldsDataArray).forEach(([key, value]) => {
            activeFields.push(value)
          })
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.$set(this.formData, 'fields', activeFields)
          this.loading = false
        })
    },
    downloadFile() {
      const base64Data = this.fileData.file

      const binaryString = atob(base64Data)

      const buffer = new ArrayBuffer(binaryString.length)
      const array = new Uint8Array(buffer)
      for (let i = 0; i < binaryString.length; i++) {
        array[i] = binaryString.charCodeAt(i)
      }

      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = this.fileData.original_name
      link.click()

      // Clean up the temporary anchor element
      URL.revokeObjectURL(link.href)
    },
    rowClass(item) {
      if (item.is_group_row == '1') {
        return `report-group-row`
      }
      return ''
    },
    compareValues(a, b) {
      if (typeof a === 'string' && typeof b === 'string') {
        return a.localeCompare(b)
      }
      if (typeof a === 'number' && typeof b === 'number') {
        return a - b
      }
      return 0
    },
    customSort(items, sortBy, sortDescArr) {
      // Unsorted data
      if (sortBy.length === 0) {
        return items
      }

      // Group data by group name
      let groupedItems = {}

      items.forEach((item) => {
        const groupName = item.group_name
        if (!groupedItems[groupName]) {
          groupedItems[groupName] = []
        }
        groupedItems[groupName].push(item)
      })

      // Sort
      const sortedGroups = {}
      const sortDesc = sortDescArr[0]

      for (const groupName in groupedItems) {
        const group = groupedItems[groupName]
        const totalItems = group.filter((item) => item.is_group_row === '1')
        const otherItems = group.filter((item) => item.is_group_row !== '1')

        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        // Sort each group
        const sortedGroup = otherItems.sort((a, b) => {
          // Sorting logic
          let aValue = a[sortBy]
          let bValue = b[sortBy]

          // Numeric
          if (aValue !== null && !dateRegex.test(aValue)) {
            let aIntValue = parseInt(aValue)
            if (!isNaN(aIntValue)) {
              aValue = aIntValue
            }
          }

          if (bValue !== null && !dateRegex.test(bValue)) {
            let bIntValue = parseInt(bValue)
            if (!isNaN(bIntValue)) {
              bValue = bIntValue
            }
          }

          // null values
          if (aValue === null && bValue === null) {
            return 0
          } else if (aValue === null) {
            return sortDesc ? 1 : -1
          } else if (bValue === null) {
            return sortDesc ? -1 : 1
          }

          // compareValues 
          if (sortDesc) {
            return this.compareValues(bValue, aValue) // Use compareValues here
          } else {
            return this.compareValues(aValue, bValue) // Use compareValues here
          }
        })
        sortedGroups[groupName] = [...totalItems, ...sortedGroup]
      }
      // Combine
      const sortedItems = Object.values(sortedGroups).flat()
      return sortedItems
    },
  },
}
</script>
<style lang="scss" scoped>
table,
th,
td {
  border: 1px solid;
}
</style>
